import {
  useState, useCallback, useEffect, useContext,
} from 'react';
import { LoadingContext } from 'context/Loading';
import AdminInvitationsServices from 'services/api/AdminInvitations';
import { buildDocumentTree, TreeNode } from 'utils/documents';
import handlePromise from 'utils/Promise';
import ProjectsService from 'services/api/Projects';

const useDocumentTree = () => {
  const { toggleLoading } = useContext( LoadingContext );
  const [futureInvestments, setFutureInvestments] = useState<{ id:string, name:string }[]>( [] );
  const [documentTree, setDocumentTree] = useState<TreeNode[]>( [] );
  const [expandedDocuments, setExpandedDocuments] = useState<string[]>( [] );
  const [basePath, setBasePath] = useState<string>( '' );

  const getDocuments = useCallback( async () => {
    toggleLoading( true );
    const [, , documentsData] = await handlePromise(
      AdminInvitationsServices.getAdminInvitationsDocuments(),
    );
    if ( documentsData?.data && documentsData.data.length > 0 ) {
      // Obtener el path base de los primeros 7 niveles del primer documento
      const firstDoc = documentsData.data[0];
      if ( firstDoc?.path ) {
        const decodedPath = decodeURIComponent( firstDoc.path );
        const hasLeadingSlash = decodedPath.startsWith( '/' );
        const parts = decodedPath.split( '/' ).filter( Boolean );
        const basePathParts = parts.slice( 0, 7 );
        const basePathValue = `${hasLeadingSlash ? '/' : ''}${basePathParts.join( '/' )}`;
        setBasePath( basePathValue );
      }
      const tree = buildDocumentTree( documentsData.data, 7 );
      setDocumentTree( tree );
    }
    setTimeout( () => toggleLoading( false ), 500 );
  }, [] );

  const getFuturaInversion = useCallback( async () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [, , futuraInversionData] = await handlePromise(
      ProjectsService.getFuturainversion( ),
    );

    if ( futuraInversionData ) {
      setFutureInvestments( futuraInversionData.data?.map( ( item:any ) => ( {
        id: item.futuraInversionId?.toString(),
        name: item.codigoPromocion,
      } ) ) );
    }
  }, [] );

  useEffect( () => {
    getDocuments();
    getFuturaInversion();
  }, [] );

  return {
    documentTree,
    expandedDocuments,
    setExpandedDocuments,
    futureInvestments,
    basePath,
  };
};

export default useDocumentTree;
